export const API_VERSION = 'v1'
export const API_PREFIX = `/${API_VERSION}`

export function buildApiPath(resourcePath: string) {
  const normalizedPath = resourcePath.trim().replace(/^\/+|\/+$/g, '')
  return normalizedPath ? `${API_PREFIX}/${normalizedPath}` : API_PREFIX
}
